import { render, staticRenderFns } from "./MealListItemSlider.vue?vue&type=template&id=25d34a7c"
import script from "./MealListItemSlider.vue?vue&type=script&lang=js"
export * from "./MealListItemSlider.vue?vue&type=script&lang=js"
import style0 from "./MealListItemSlider.vue?vue&type=style&index=0&id=25d34a7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports